import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';

export const searchVideos = (query, cancelToken) =>
  service.get(apiEndpoints.VIMEO_SEARCH, { query }, cancelToken);
